import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const ComponentHomolog = ({ empresa = null, settings }) => {

    function getURL() {
        let AResponse = document.location.origin.replace("https://", "https://c") + "/dashboards";
        AResponse += "?empresa=" + empresa;
        AResponse += "&token=" + sessionStorage.getItem("jwt_access_token");
        AResponse += "&usuario=" + sessionStorage.getItem("username");
        AResponse += "&theme=" + sessionStorage.getItem('theme').replace("#", "");
        AResponse += "&themetype=" + sessionStorage.getItem('themetype');
        AResponse += "&segmento=" + (settings.tipo);

        return AResponse;
    }

    return (
        <React.Fragment>
            <iframe src={getURL()} width={"100%"} height={"100%"}>
            </iframe>
        </React.Fragment>
    )
};

function mapStateToProps({ fuse, auth }) {
    return {
        settings: auth.user.data.settings,
        empresa: fuse.navigation.empresa,
    };
}

export default withRouter(connect(mapStateToProps)(ComponentHomolog));
